var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyboardBackspace = function SvgKeyboardBackspace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.227 15.654 2.6-2.6 2.6 2.6 1.054-1.054-2.6-2.6 2.6-2.6-1.054-1.054-2.6 2.6-2.6-2.6L10.173 9.4l2.6 2.6-2.6 2.6zM9.087 19.5a1.82 1.82 0 0 1-1.446-.713L2.5 12l5.14-6.786q.249-.335.633-.525.384-.189.813-.189h10.606q.746 0 1.277.531t.531 1.277v11.384q0 .746-.531 1.277a1.74 1.74 0 0 1-1.277.531zM4.374 12l4.461 5.884a.32.32 0 0 0 .25.116h10.606a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22V6.307a.3.3 0 0 0-.087-.221.3.3 0 0 0-.22-.087H9.085a.3.3 0 0 0-.139.029.3.3 0 0 0-.11.087z"
  })));
};
export default SvgKeyboardBackspace;